import { APP_ROUTES } from 'constants/routes';
import { getOpenGraphUrl, getPageSeoBreadcrumbs, getPaginationCanonical } from 'helpers/SeoHelpers/SeoHelpers';

import type {
  ICategoryPageUrlParams, ICategoryProductsListing, PageSeoProps, TFunction
} from 'types';

export function getCategoryPageSeoProps(t: TFunction, urlParams: ICategoryPageUrlParams, category?: ICategoryProductsListing): PageSeoProps {

  if (!category) return { seoProps: undefined, breadcrumbs: undefined };

  const { indexable } = urlParams;
  const {
    metaTitle, metaDescription, name
  } = category?.payload || {};

  return {
    seoProps: {
      title: metaTitle || name,
      description: metaDescription,
      openGraph: {
        url: getOpenGraphUrl(),
        description: metaDescription
      },
      noindex: !indexable,
      canonical: getPaginationCanonical(urlParams)
    },
    breadcrumbs: getPageSeoBreadcrumbs(t, category?.payload?.breadcrumbs || [], { base: APP_ROUTES.CATEGORIES, includesLast: true })
  };
}
